export default "__VITE_ASSET__CL_5fW9m__"